import { FeatureKey } from "../enums/feature-keys";
import {
  LEARN_FEATURES_ENABLE_RC_KEY,
  mergeAinaFeatureFlagsWithLearnPartial,
  partialAinaFlagsFromLearnFeaturesPayload,
} from "./ainaLearnFeaturesEnable";
import {
  classifyAinaAgentForMicDoubtsRemoteKeys,
  type AinaAndroidFeatureFlags,
} from "./ainaNativeLaunchProps";

function readBooleanFlag(
  flags: Record<string, unknown>,
  key: FeatureKey,
  fallback: boolean,
): boolean {
  const v = flags[key];
  if (typeof v === "boolean") {
    return v;
  }
  if (typeof v === "number") {
    return v !== 0;
  }
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    if (s === "true" || s === "1") {
      return true;
    }
    if (s === "false" || s === "0") {
      return false;
    }
  }
  return fallback;
}

export function ainaFeatureFlagsFromRemoteConfig(
  flags: Record<string, unknown>,
): AinaAndroidFeatureFlags {
  const base = {
    ainaDisableMic: readBooleanFlag(flags, FeatureKey.AINA_DISABLE_MIC, false),
    ainaDisableDoubts: readBooleanFlag(
      flags,
      FeatureKey.AINA_DISABLE_DOUBTS,
      false,
    ),
  };
  const fromLearn = partialAinaFlagsFromLearnFeaturesPayload(
    flags[LEARN_FEATURES_ENABLE_RC_KEY] ??
      (flags as Record<string, unknown>).learnFeaturesEnable,
  );
  return mergeAinaFeatureFlagsWithLearnPartial(base, fromLearn);
}

export function ainaMicDoubtsPropsFromRemoteConfig(
  agent: string | undefined,
  remoteFlags: Record<string, unknown>,
): { disableMic: boolean; disableDoubts: boolean } {
  const merged = ainaFeatureFlagsFromRemoteConfig(remoteFlags);
  const isMentor = classifyAinaAgentForMicDoubtsRemoteKeys(agent) === "mentor";
  const disableMic = merged.ainaDisableMic ?? false;

  return {
    disableMic,
    disableDoubts: isMentor ? true : (merged.ainaDisableDoubts ?? false),
  };
}
